import * as Yup from "yup";
import form from "./form";

const {
  formField: { title, url },
} = form;

const validations = Yup.object().shape({
  [title.name]: Yup.string()
    .min(5, "Title is too short")
    .max(20, "Title is too long")
    .required("Title is required"),
  [url.name]: Yup.string().url("Invalid URL format").required("URL is required"),
});

export default validations;
